import { render, staticRenderFns } from "./chooseCgtag.vue?vue&type=template&id=881e6a84&scoped=true&"
import script from "./chooseCgtag.vue?vue&type=script&lang=js&"
export * from "./chooseCgtag.vue?vue&type=script&lang=js&"
import style0 from "./chooseCgtag.vue?vue&type=style&index=0&id=881e6a84&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "881e6a84",
  null
  
)

export default component.exports